import {Component, Inject} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AdminService} from "../../services/admin.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-edit-result',
  templateUrl: './edit-result.component.html',
  styleUrls: ['./edit-result.component.scss']
})
export class EditResultComponent {
  nationalGameForm: FormGroup;
  isEditMode: boolean;

  constructor(
    private fb: FormBuilder,
    private adminService: AdminService,
    public dialogRef: MatDialogRef<EditResultComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { nationalGames: any }
  ) {
    this.isEditMode = !!data.nationalGames?.id;
    this.nationalGameForm = this.fb.group({
      homeTeamScore: [data.nationalGames?.homeTeamScore || 0, Validators.required],
      awayTeamScore: [data.nationalGames?.awayTeamScore || 0, Validators.required],
    });
  }

  saveGame() {
    if (this.nationalGameForm.valid) {
      const gameData = this.nationalGameForm.value;

      this.adminService.updateScore(this.data.nationalGames.id, {
        homeTeamScore: gameData.homeTeamScore,
        awayTeamScore: gameData.awayTeamScore,
      }).subscribe(() => {
        this.dialogRef.close(true);
      });

    }
  }

  cancel() {
    this.dialogRef.close();
  }
}
